// Tema claro/escuro. A classe fica no <html>, e todo o resto vira de graca
// porque os utilitarios do Tailwind consomem as CSS custom properties que o
// .dark redefine (ver src/index.css).

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'pdmp-theme';

/** Preferencia salva; se nao houver, segue a do sistema operacional. */
export function getStoredTheme(): Theme {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(theme: Theme): void {
  document.documentElement.classList.toggle('dark', theme === 'dark');
  localStorage.setItem(STORAGE_KEY, theme);
}

/**
 * Aplica o tema ANTES do React montar, para nao piscar branco no carregamento.
 * Chamado de main.tsx, fora do ciclo de render.
 */
export function initTheme(): Theme {
  const theme = getStoredTheme();
  document.documentElement.classList.toggle('dark', theme === 'dark');
  return theme;
}
